// removed by extract-text-webpack-plugin
module.exports = {"iconDefault":"_279rGuhwFLB31WmS7OhKEq"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Icons/dist/Icon.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Icons/dist/Icon.scss
// module chunks = 0